/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Right_To_LeftInputs */

const en_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right-To-Left`)
};

const fr_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droite vers gauche`)
};

const de_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von rechts nach links`)
};

const it_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da destra a sinistra`)
};

const ru_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Справа налево`)
};

const es_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De derecha a izquierda`)
};

const zh_cn2_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从右到左`)
};

const ja_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右から左へ`)
};

const hi_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दाएँ से बाएँ`)
};

const pt_pt2_right_to_left = /** @type {(inputs: Right_To_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da direita para a esquerda`)
};

/**
* | output |
* | --- |
* | "Right-To-Left" |
*
* @param {Right_To_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const right_to_left = /** @type {((inputs?: Right_To_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Right_To_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_right_to_left(inputs)
	if (locale === "de") return de_right_to_left(inputs)
	if (locale === "it") return it_right_to_left(inputs)
	if (locale === "ru") return ru_right_to_left(inputs)
	if (locale === "es") return es_right_to_left(inputs)
	if (locale === "zh-CN") return zh_cn2_right_to_left(inputs)
	if (locale === "ja") return ja_right_to_left(inputs)
	if (locale === "hi") return hi_right_to_left(inputs)
	if (locale === "pt-PT") return pt_pt2_right_to_left(inputs)
	return en_right_to_left(inputs)
});